export default __webpack_public_path__ + "static/media/logo-e-commerce.c0bc67a9.png";